import { useRef } from "react";
import SvgSearch from "./icons/Search";

type Props = {
  value?: string;
  loading: boolean;
  onSubmit: (ad: string) => void;
};

export function Search({ value, onSubmit, loading }: Props) {
  const ref = useRef<HTMLInputElement>(null);

  const submit = () => {
    const ad = ref.current?.value;
    if (ad) {
      onSubmit(ad);
    }
  };

  return (
    <div className="card-content mx-auto flex w-full gap-8 px-16 md:gap-16">
      <div className="has-prefix">
        <div className="relative mb-0 text-16 leading-22">
          <label
            style={{ opacity: loading ? 0 : 1 }}
            className="inline-block pb-6 text-14 font-bold transition-opacity duration-300"
            htmlFor="previewSearch"
          >
            Se din annonse med Blink
          </label>
          <form
            className="relative"
            onSubmit={(e) => {
              submit();
              e.preventDefault();
            }}
          >
            <input
              style={{ transitionDelay: "120ms" }}
              ref={ref}
              className={`${
                loading
                  ? "loading border-green-100 text-green-100"
                  : "border-blue-alt-900 text-blue-alt-900"
              } preloader-item block w-full max-w-max rounded-full border-2 bg-green-100 px-8 py-12 pl-40`}
              type="text"
              id="previewSearch"
              defaultValue={value}
            />
            <button
              type="submit"
              className="hover:text-homemade absolute bottom-0 left-0 top-0 flex w-40 items-center justify-center focus-ring"
              onClick={submit}
            >
              <SvgSearch
                style={{ opacity: loading ? 0 : 1 }}
                className="transition-opacity duration-300"
              />
            </button>
          </form>
        </div>
      </div>
      <button
        type="button"
        className={`bg-blue-alt-900 hover:bg-homemade focus:bh-homemade preloader-item mt-auto max-w-max flex-shrink-0 rounded-full px-16 py-12 font-bold leading-24 text-green-400 ${
          loading ? "loading" : "not-loading"
        }`}
        onClick={submit}
      >
        <span
          style={{ opacity: loading ? 0 : 1 }}
          className="whitespace-nowrap transition-opacity duration-300"
        >
          Vis annonsen
        </span>
      </button>
    </div>
  );
}
